export const SEND_INSTRUCTIONS_RESOURCE = 'forget_password'
export const SEND_INSTRUCTIONS_REQUEST = 'SEND_INSTRUCTIONS_REQUEST'
export const SEND_INSTRUCTIONS_SUCCESS = 'SEND_INSTRUCTIONS_SUCCESS'
export const SEND_INSTRUCTIONS_FAILED = 'SEND_INSTRUCTIONS_FAILED'

export const RESET_PASSWORD_RESOURCE = 'reset_password'
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED'



// WEBPACK FOOTER //
// ./src/services/password-reset/constants.js